import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { AccountWishlistComponentDef } from '@df/account/account-wishlist.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ProductComponent } from '../../catalog/product/product/product.component';
import { AccountBackComponent } from '../back/account-back.component';
import { AccountViewComponent } from '../view/account-view.component';
@Component({
    selector: 'account-wishlist',
    templateUrl: './account-wishlist.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, AccountBackComponent, ProductComponent, ICmsClientModule]
})
export class AccountWishlistComponent extends AccountWishlistComponentDef implements OnDestroy {
    constructor(
        ref: ChangeDetectorRef,
        private accountViewComponent: AccountViewComponent
    ) {
        super(ref);
        this.accountViewComponent.forceContentCols = 9;
    }
    override ngOnDestroy(): void {
        this.accountViewComponent.forceContentCols = undefined;
        super.ngOnDestroy();
    }
}
